<template>
  <div v-show="Display" :style="{zIndex:$refs.imageViewer?.isOpen || $refs.statusViewer?.Display ||  post.showReport ? 2000 : 100}" class="profile-page">
    <button v-if="showedMode" class="back-button" @click="hide">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
    </button>
    <button v-else class="back-button logout-btn" @click="$refs.alertWLogOut.show('Do you really want to log out ?','Logging out')" aria-label="Log out">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round"
        width="22" height="22" aria-hidden="true">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
        <polyline points="16 17 21 12 16 7"/>
        <line x1="21" y1="12" x2="9" y2="12"/>
      </svg>
    </button>
     <!-- Follows Back Icon (top right) -->
    <div class="follows-back-icon" v-if="infos.followed">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <polyline points="16 3.27 18 5.27 22 1.27"/>
      </svg>
    </div>
    <!-- Profile Header -->
    <div class="profile-header">
      <!-- Profile Picture -->
      <div @click="$refs.imageViewer.openViewer()" class="profile-picture">
        <img :src="!infos.profilImgMini1? require('./img/profile.svg'):imagesMini[0]" />
      </div>

      <!-- Status Badges -->
      <div class="status-badges">
        <div @click="$refs.statusViewer.showForOneUser([infos], infos.status)" class="badge badge-status" v-if="!!infos.status">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="12" r="10"/>
          </svg>
          <span>New Status</span>
        </div>
        <div @click="$store.commit('setCurrentConference', infos.conference);$router.push('/home')" 
              class="badge badge-conference" v-if="!!infos.conference">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
          </svg>
          <span>In Conference</span>
        </div>
      </div>

      <!-- Username -->
      <h1 class="username">{{ infos.name }}</h1>
      <p class="handle">@{{ infos.pseudo }}</p>

      <!-- Stats -->
      <div class="stats">
        <div class="stat-item">
          <div class="stat-number">{{ formatViews(infos.stats?.followings) }}</div>
          <div class="stat-label">Following</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">{{ formatViews(infos.stats?.followers) }}</div>
          <div class="stat-label">Followers</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">{{ formatViews(infos.stats?.likes) }}</div>
          <div class="stat-label">Likes</div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button v-if="!isMyProfile && !infos.following" class="btn-follow" @click="follow(this,'follow')">Follow</button>
        <button v-if="!isMyProfile && infos.following" class="btn-message" @click="follow(this,'unfollow')">Unfollow</button>
        <button v-if="!isMyProfile" class="btn-message" @click="handleMessage">Message</button>
        <button v-if="isMyProfile" class="btn-message" @click="$refs.editProfile.show()">Edit profile</button>
        <button v-if="isMyProfile" class="btn-message" @click="$refs.editProfile.show()">Friends</button>
        <DropDown @deleteAccount="$refs.alertWConfirm.show('Voulez-vous vraiment supprimer votre compte ? Toutes les donnees de ce compte seront perdues.')" 
                  @blockAccount="$refs.alertWConfirm1.show('Voulez-vous vraiment blocker ce compte ? Il ne vera plus vos informations.')" 
                  @blockedList="$refs.blockedAccounts.show(infos.blockedUser)"
                  @reportPublication="post.showReport = true"
                  :isMyProfile="isMyProfile"
                  :toShare="$store.state.baseUrl+'profile/'+infos.uid"
        />
      </div>

      <!-- Bio -->
      <div class="bio">
        <p class="location">{{ infos.description }}</p>
      </div>
      <SlidingMenu ref="slidingMenu" :canSeePrivate="(infos.following && infos.followed) || isMyProfile" 
          :parentPseudo="infos.pseudo"
      />
    </div>
    <EditProfile ref="editProfile" @updateImage="updateImage" @updateText="updateText" style="z-index: 3;"/>
    <BlockedAccounts ref="blockedAccounts"  style="z-index: 3;"/>
    <Loader :loading="loading" />
    <AlertW type="warning" ref="alertWConfirm1" :showCancel="true" @confirm="blockAccount(this)" />
    <AlertW type="warning" :showCancel="true" @confirm="deleteAccount(this)" ref="alertWConfirm" />
    <AlertW v-if="!showedMode" type="warning" :showCancel="true" @confirm="logOut" ref="alertWLogOut" />
    <ReportForm
      v-if="post.showReport"
      :reported-user-name="infos.name"
      :reported-user-id="infos.uid"
      :prefill-link="post.url"
      @close="post.showReport = false"
      @submitted="post.showReport = false"
      ref="reportForm"
    />
    <ImageViewer ref="imageViewer" :images="imageList" :imagesMini="imageMiniList" style="z-index: 2;"/>
    <StatusViewer ref="statusViewer" />
  </div>
</template>

<script>
import DropDown from './components/DropDown.vue'
import ImageViewer from '@/views/components/ImageViewer.vue'
import SlidingMenu from './components/SlidingMenu.vue'
import EditProfile from './components/EditProfile.vue'
import Loader from "@/views/components/loader/Loader.vue"
import AlertW from "@/views/components/alertW/AlertW.vue"
import BlockedAccounts from "./components/BlockedAccounts.vue"
import StatusViewer from '@/views/status/Status.vue';
import ReportForm from './components/ReportForm.vue'

export default {
  name: 'ProfilePage',
  props:{
    visible:{ // to initialize Display on mounted
      type:Boolean,
      default:true
    }
  },
  components: {
    ReportForm,
    DropDown,
    ImageViewer,
    SlidingMenu,
    EditProfile,
    Loader,
    AlertW,
    BlockedAccounts,
    StatusViewer
  },
  computed: {
    imageList () { return this.images.filter(img => !!img)},
    imageMiniList () { return this.imagesMini.filter(img => !!img)}
  },
  data() {
    return {
      Display:true,
      baseUrl:this.$store.state.baseUrl+"images/",
      isMyProfile:false,
      hasNewStatus: false, // Set to true to show status ring
      isInConference: false, // Set to true to show conference badge
      loading:false,
      images:[],
      imagesMini:[],
      //----- repot
      post: {authorName:'', authorId:'', url:'',showReport:false},
      //------, 
      infos: {},
      showedMode:false // if has been showed , i guess if it is not a page
    }
  },
  methods: {
    hide() {
      if(this.$refs.alertWLogOut?.display) { this.$refs.alertWLogOut.handleClose(); return false }
      if(this.$refs.alertWConfirm.display) { this.$refs.alertWConfirm.handleClose(); return false }
      if(this.$refs.alertWConfirm1.display) { this.$refs.alertWConfirm1.handleClose(); return false }
      if(this.$refs.editProfile.Display) { this.$refs.editProfile.handleBack(); return false }
      if(this.$refs.blockedAccounts.display) { this.$refs.blockedAccounts.close(); return false }
      if(this.post.showReport === true) { this.post.showReport = false; return false }
      if(this.$refs.statusViewer.Display) { this.$refs.statusViewer.close(); return false}
      if(this.$refs.imageViewer.isOpen) { this.$refs.imageViewer.closeViewer(); return false }
      this.Display = false
      this.$refs.slidingMenu.reset()
      return true
    },
    async logOut () {
      //localStorage.clear()
      this.loading = true
      try {
        const res = await this.$axios.post('auth/logout')
        console.log(res.data)
      } catch (e) {console.log(e)}
      finally { this.loading = false }
      
      // before clearing auth state
      const token = localStorage.getItem('pushToken')
      if (token) {
        try { 
          await this.$axios.post('/notification.php', { type: 'unregisterToken', token })
          localStorage.removeItem('pushToken')
        } catch (e) { console.log('non blocking on failure');alert(JSON.stringify(e))}
      }
      
      this.$axios.clearAccessToken()
      this.$store.commit("setUser",{uid:'',stats:{}, blockedUser:[]}) // disconnect on store
      
      localStorage.removeItem('playLists__')
      localStorage.removeItem('currentUser__')
      localStorage.removeItem('messages')
      localStorage.removeItem('users')
      
      this.$router.push('/')
    },
    handleMessage() {
      this.$store.commit('setAnUser',this.infos) // save globally user
      this.$store.commit('showChat',this.infos)
    },
    handleMore() {
      console.log('More clicked');
      this.$emit('more');
    },
    formatViews(views) {
      if(!views) return 0
      if (views >= 1000000) {
        return (views / 1000000).toFixed(1) + 'M';
      } else if (views >= 1000) {
        return (views / 1000).toFixed(1) + 'K';
      }
      return views.toString();
    },
    async getUser () {
      this.loading = true // show loader if nothing in store
      try {
          const res = await this.$axios.post('user.php',{type:"getUser",user:this.infos.uid})
          console.log(res.data)
          if(!res.data?.name) {
            this.infos = {name:"Account not found."}
            return
          }
          this.infos = res.data
          this.setImages(res.data)
          this.$store.commit('setUserProfile',res.data)
          //if(this.isMyProfile) this.$store.commit('setUser',res.data)
      } catch (e) {
          console.log(e.response)
          if(e.response?.status == 500) this.infos = {name:"Account not found."}
      } finally {this.loading = false}
    },
    async deleteAccount (k) {
      this.loading = true 
      try {
          await k.$axios.post('user.php',{type:"removeAccount"})
          this.infos = {name:"Account deleted"}
          this.setImages([])
          this.$store.commit('setUser',{name:"Account deleted"})
          this.$store.commit('setUserProfile',{name:"Account deleted"})
          localStorage.removeItem("currentUser__")

          this.loading = false
      } catch (e) {
          console.log(e.response)
          this.loading = false
      }
    },
    async blockAccount (k) {
      this.loading = true 
      try {
          await k.$axios.post('user.php',{type:"blockUser",userId:k.infos.uid,name:k.infos.name})
          this.infos = {name:"Account blocked"}
          this.setImages([])

          this.loading = false
      } catch (e) {
          console.log(e.response)
          this.loading = false
      }
    },
    async follow (k,type) {
      this.loading = true 
      try {
          await k.$axios.post('friendship.php',{type:type,following:k.infos.uid})
          k.infos.following = type === 'follow' ? true : false
          k.infos.stats.followers = type === 'follow' ? k.infos.stats.followers+1 : k.infos.stats.followers-1
          k.loading = false
      } catch (e) {
          console.log(e.response)
          k.loading = false
      }
    },
    setImages (data) {
      let imagesMini = [
        data.profilImgMini1 ? this.baseUrl + data.profilImgMini1 : null,
        data.profilImgMini2 ? this.baseUrl + data.profilImgMini2 : null,
        data.profilImgMini3 ? this.baseUrl + data.profilImgMini3 : null,
        data.profilImgMini4 ? this.baseUrl + data.profilImgMini4 : null,
        data.profilImgMini5 ? this.baseUrl + data.profilImgMini5 : null,
      ]
      this.$refs.editProfile.setImages(imagesMini,data)
      this.imagesMini = imagesMini
      this.images = [
        data.profilImg1 ? this.baseUrl+data.profilImg1 : null,
        data.profilImg2 ? this.baseUrl+data.profilImg2 : null,
        data.profilImg3 ? this.baseUrl+data.profilImg3 : null,
        data.profilImg4 ? this.baseUrl+data.profilImg4 : null,
        data.profilImg5 ? this.baseUrl+data.profilImg5 : null,
      ]
    },
    updateImage(pl) {
     this.imagesMini[pl.index] = pl.image
     this.images[pl.index] = pl.image
    },
    updateText(pl) {
     this.infos[pl.elt] = pl.val
    },
    show (infos) {
      this.Display = true
      this.showedMode = true
      //----------------
      this.infos = infos
      this.isMyProfile = false
      //----- let's check on vue store --
      const userInfos = this.$store.state.user
      if(userInfos.uid === infos.uid ) {
        this.isMyProfile = true
        this.infos = userInfos
      }
      // let's get data
      this.setImages(infos)
      this.getUser(this)
      this.$refs.slidingMenu.getPubs('public',this.infos.uid)
    }
  },
  mounted () {
    this.Display = this.visible
    if(!this.visible) return

    // put previous page saved data
    this.infos = this.$store.state.userProfile
    this.infos.uid = this.$route.params.uid
    this.isMyProfile = false
    
/*     alert('Current user '+this.$store.state.user.uid)
    alert('Params uid '+this.$route.params.uid) */
    //----- let's check on vue store  --
    const userInfos = this.$store.state.user
    if(userInfos.uid === this.$route.params.uid ) {
      this.isMyProfile = true
      this.infos = userInfos
    }
    // let's get data
    this.setImages(this.infos)
    this.getUser()
    this.$refs.slidingMenu.getPubs('public',this.infos.uid)
  },
  beforeRouteLeave (/*to, from*/) {
    if(this.showedMode) return
    if(this.$store.state.publicationFormVisible) {
      this.$store.commit('setPublicationFormVisibility',false)
      return false
    }
    if(this.$store.state.audioPlayerVisibility === true) {
      this.$store.commit('setAudioPlayerVisibility',false)
      return false
    }
    return this.hide()
  }
}
</script>

<style src="./profile.css" scoped>
</style>